export const toHValue = (value) => {
    return isNaN(value) ? "非法条件" : value;
}
